import { Redirect, RedirectProps, usePathname } from "expo-router";

import { isDev, isLocal } from "@/config/env";
import { usePropagatedHref } from "@/hooks/usePropagatedRouter";
import { addBreadcrumb } from "@/sentry";

interface BreadcrumbRedirect extends RedirectProps {
  reason: string;
  context?: Record<string, unknown>;
}

export default function BreadcrumbRedirect({
  reason,
  context,
  href,
  ...props
}: BreadcrumbRedirect) {
  const currentPath = usePathname();
  const propagatedHref = usePropagatedHref(href);
  const message = `Redirecting from ${currentPath} to ${href}: ${reason}${
    context ? ` — ${JSON.stringify(context)}` : ""
  }`;
  addBreadcrumb({
    category: "navigation",
    level: "info",
    message,
  });
  if (isDev || isLocal) {
    console.log(message, context);
  }

  return <Redirect href={propagatedHref} {...props} />;
}
